import { render, staticRenderFns } from "./ADeviceDetail4.vue?vue&type=template&id=1908df93&scoped=true"
import script from "./ADeviceDetail4.vue?vue&type=script&lang=js"
export * from "./ADeviceDetail4.vue?vue&type=script&lang=js"
import style0 from "./ADeviceDetail4.vue?vue&type=style&index=0&id=1908df93&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908df93",
  null
  
)

export default component.exports